module.exports = __webpack_public_path__ + "img/full-slide-3.c5570b40.jpg";